import React, { useState, useEffect, useCallback } from 'react'; // أضف useCallback
import { useParams, useLocation, Link } from 'react-router-dom';
import { Container, Button, Spinner } from 'react-bootstrap';
import LatestProperties from '../../components/LatestProperties/LatestProperties';
import { supabase } from '../../lib/supabase';

const CategoryPage = () => {
  const { type, status } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cityFilter = queryParams.get('city');
  
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFilteredProperties = useCallback(async () => {
    try {
      setLoading(true);
      
      let query = supabase
        .from('properties')
        .select('*');
      
      if (type) {
        query = query.eq('type', type);
      }
      
      if (status) {
        query = query.eq('ownership', status);
      }
      
      if (cityFilter) {
        query = query.eq('city->>ar', cityFilter);
      }
      
      query = query.order('created_at', { ascending: false });
      
      const { data, error } = await query;
      
      if (error) {
        console.error('Supabase error:', error);
        setFilteredData([]);
        return;
      }
      
      setFilteredData(data || []);
      
    } catch (err) {
      console.error('Error:', err);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  }, [type, status, cityFilter]);

  useEffect(() => {
    fetchFilteredProperties();
  }, [fetchFilteredProperties]);

  const getArabicTitle = () => {
    const typesAr = { 
      apartment: 'شقق', 
      house: 'بيوت', 
      land: 'أراضي' 
    };
    
    const statusAr = { 
      sale: 'للبيع', 
      rent: 'للإيجار' 
    };
    
    let title = `${typesAr[type] || 'عقارات'} ${statusAr[status] || ''}`;
    
    if (cityFilter) {
      title += ` في ${cityFilter}`;
    }
    
    return title;
  };

  const primaryButtonStyle = {
    backgroundColor: '#003591',
    borderColor: '#003591',
    color: '#fff',
    transition: '0.3s'
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">جاري البحث عن العقارات...</p>
      </Container>
    );
  }

  return (
    <div className="container-fluid">
      {filteredData.length > 0 ? (
        <LatestProperties 
          properties={filteredData} 
          title={getArabicTitle()} 
        />
      ) : (
        <Container className="text-center py-5 my-5 border-0 rounded-4" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="py-5 px-3" style={{ border: '2px dashed #dee2e6', borderRadius: '20px' }}>
            <div className="mb-4">
              <span style={{ fontSize: '50px' }}>🔍</span>
            </div>
            <h3 className="text-dark fw-bold mb-3">عذراً، لم نجد نتائج لـ "{getArabicTitle()}"</h3>
            <p className="text-muted mb-4 mx-auto" style={{ maxWidth: '500px' }}>
              لا توجد عقارات حالياً ضمن هذه الفئة في {cityFilter || 'المنطقة المحددة'}. يمكنك تصفح كافة العقارات أو تغيير خيارات البحث.
            </p>
            
            <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-4">
              <Button 
                as={Link} 
                to="/" 
                style={primaryButtonStyle}
                className="px-5 py-2 fw-bold shadow-sm"
              >
                العودة للرئيسية
              </Button>
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default CategoryPage;